import { render } from "./vpartnerdvclist.vue?vue&type=template&id=a5e8d58c&scoped=true"
import script from "./vpartnerdvclist.vue?vue&type=script&lang=js"
export * from "./vpartnerdvclist.vue?vue&type=script&lang=js"

import "./vpartnerdvclist.vue?vue&type=style&index=0&id=a5e8d58c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e8d58c"]])

export default __exports__